/**
 * LP_FORM_HANDLER_SCRIPT
 *
 * Vanilla JS string that gets embedded INLINE into exported landing page HTML
 * as <script id="lp-form-handler">. Not served over HTTP — React-side only.
 *
 * Reads window.__LP_FORM__ = { endpoint, apiKey, createdBy, redirectUrl }
 * and attaches submit handlers to all <form> elements on the page.
 */
export const LP_FORM_HANDLER_SCRIPT = `(function(){
  var cfg = window.__LP_FORM__;
  if (!cfg || !cfg.endpoint || !cfg.apiKey) return;

  var FIELD_MAP = {
    nombre: 'name', name: 'name', fullname: 'name',
    apellido: 'lastName', apellidos: 'lastName', lastname: 'lastName',
    email: 'email', correo: 'email', 'e-mail': 'email',
    telefono: 'phone', phone: 'phone', tel: 'phone', celular: 'phone', movil: 'phone', whatsapp: 'phone', wa: 'phone', numero: 'phone', mobile: 'phone',
    countrycode: 'countryCode', codigopais: 'countryCode', prefijo: 'countryCode', pais: 'countryCode', country: 'countryCode', lada: 'countryCode',
  };

  function normalizeKey(k) {
    return k.toLowerCase().replace(/[^a-z]/g, '');
  }

  function attachPhoneGuards(form) {
    var phoneInput = form.querySelector('input[name="phone"], input[type="tel"]');
    if (phoneInput && !phoneInput.__lpGuarded) {
      phoneInput.__lpGuarded = true;
      phoneInput.setAttribute('inputmode', 'numeric');
      phoneInput.setAttribute('maxlength', '10');
      phoneInput.addEventListener('input', function() {
        this.value = this.value.replace(/\\D/g, '').slice(0, 10);
      });
    }
  }

  function attachForm(form) {
    if (form.__lpAttached) return;
    form.__lpAttached = true;
    attachPhoneGuards(form);

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando...'; }

      var payload = {};
      var extras = {};
      var countryCode = '';
      Array.from(form.elements).forEach(function(el) {
        if (!el.name || el.type === 'submit' || el.type === 'button') return;
        var key = FIELD_MAP[normalizeKey(el.name)] || null;
        var val = (el.value || '').trim();
        if (key === 'countryCode') { countryCode = val; return; }
        if (key) {
          payload[key] = val;
        } else {
          extras[el.name] = val;
        }
      });

      if (payload.phone) {
        var rawPhone = String(payload.phone).trim();
        var alreadyPrefixed = rawPhone.charAt(0) === '+';
        var digits = rawPhone.replace(/\\D/g, '');
        if (alreadyPrefixed) {
          payload.phone = '+' + digits;
        } else {
          if (digits.length !== 10) {
            if (btn) { btn.disabled = false; btn.textContent = originalText; }
            var err = form.querySelector('.lp-form-error');
            if (!err) {
              err = document.createElement('p');
              err.className = 'lp-form-error';
              err.style.cssText = 'color:#dc2626;font-size:13px;margin:10px 0 0;text-align:center;';
              form.appendChild(err);
            }
            err.textContent = 'El tel\\u00e9fono debe tener 10 d\\u00edgitos.';
            return;
          }
          var cc = countryCode || '+52';
          if (cc.charAt(0) !== '+') cc = '+' + cc.replace(/\\D/g, '');
          payload.phone = cc + digits;
        }
      }

      if (Object.keys(extras).length > 0) {
        payload.attributes = Object.assign(payload.attributes || {}, extras);
      }

      if (!payload.lastName) payload.lastName = '';
      if (cfg.createdBy) payload.createdBy = cfg.createdBy;
      payload.url = window.location.href;

      fetch(cfg.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': cfg.apiKey
        },
        body: JSON.stringify(payload)
      })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function() {
        if (cfg.redirectUrl) {
          window.location.href = cfg.redirectUrl;
        } else {
          if (btn) {
            btn.textContent = '\\u00a1Registrado! \\u2713';
            btn.style.background = '#16a34a';
          }
          form.reset();
        }
      })
      .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        var errEl = form.querySelector('.lp-form-error');
        if (!errEl) {
          errEl = document.createElement('p');
          errEl.className = 'lp-form-error';
          errEl.style.cssText = 'color:#dc2626;font-size:13px;margin:10px 0 0;text-align:center;';
          form.appendChild(errEl);
        }
        errEl.textContent = 'Hubo un error al enviar. Por favor intenta de nuevo.';
      });
    });
  }

  document.querySelectorAll('form').forEach(attachForm);

  var obs = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'FORM') attachForm(n);
        if (n.querySelectorAll) n.querySelectorAll('form').forEach(attachForm);
      });
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();`;
